module.exports = __webpack_public_path__ + "img/xcx2wm.d7bcedcf.jpg";